export default class CookieJar {
    document;
    cookies = {};
    constructor(document) {
        this.document = document;
        this.document.cookie.split('; ').forEach((cookie) => {
            let [key, value] = cookie.split('=');
            this.cookies[key] = value;
        });
    }
    has(key) {
        return key in this.cookies;
    }
    get(key) {
        return this.has(key) ? this.cookies[key] : '';
    }
    set(key, value, options) {
        let cookie = `${key}=${value}`;
        if (options?.length) {
            cookie = `${cookie}; ${options}`;
        }
        this.document.cookie = cookie;
    }
}
